export const FEEDING_TIPS_WEBSITE = 'https://discover.thefarmersdog.com/';
